import { Link } from 'react-router-dom';

const ACTIONS = [
  { to: '/dashboard/crypto/orders', label: 'View Orders', symbol: '\u03A3' },
  { to: '/dashboard/settings', label: 'Settings', symbol: '\u2699' },
  { to: '/api-docs', label: 'API Docs', symbol: '#' },
  { to: '/dashboard/crypto/payouts', label: 'View Payouts', symbol: '\u039E' },
];

export default function QuickActions() {
  return (
    <div className="flex flex-wrap gap-2 mb-6">
      {ACTIONS.map((a) => (
        <Link
          key={a.to}
          to={a.to}
          className="inline-flex items-center gap-2 rounded px-3 py-1.5 font-mono text-xs transition-colors"
          style={{ border: '1px solid var(--dash-border)', background: 'var(--dash-input)', color: 'var(--dash-text-muted)' }}
          onMouseEnter={(e) => { e.currentTarget.style.color = 'var(--dash-text-secondary)'; e.currentTarget.style.borderColor = 'var(--dash-active-border)'; }}
          onMouseLeave={(e) => { e.currentTarget.style.color = 'var(--dash-text-muted)'; e.currentTarget.style.borderColor = 'var(--dash-border)'; }}
        >
          <span className="text-[11px]">{a.symbol}</span>
          {a.label}
        </Link>
      ))}
    </div>
  );
}
